import { css } from '@compiled/react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Tooltip } from '@/libraries/design/components/tooltip/src/tooltip';
import { DEFAULT_VALUES } from '@/libraries/web-framework/src/localization/values';

import { FormattedPriceCalculationResponse } from '../constants';
import { usePriceFinderStore } from '../store/store';

const userTierContainerStyles = css({
	display: 'flex',
});

const userTierMessageStyles = css({
	fontSize: '14px',
});

const toolTipContainerStyles = css({
	display: 'flex',
	gap: '4px',
});

export type UserTierProps = {
	priceCalc: FormattedPriceCalculationResponse;
};

export const UserTier = ({ priceCalc }: UserTierProps) => {
	const { formattedBreakdown } = priceCalc;

	const [{ messages }] = usePriceFinderStore();

	const fmtBreakdownTier = formattedBreakdown[formattedBreakdown.length - 1];
	if (!fmtBreakdownTier) {
		throw new Error('No breakdown provided for user tier.');
	}

	const {
		formattedUnitLimitLower,
		formattedUnitLimitUpper,
		formattedUnitsInTier,
		formattedUnitsAvailableInTier,
	} = fmtBreakdownTier;

	const { formatMessage } = useIntl();
	const tooltipAriaLabel = formatMessage({
		id: 'Pricing.PriceCard.UserTier.MoreInformationAboutTier',
		defaultMessage: 'More information about tier',
	});
	const filledSeatsMessage = formatMessage({
		id: 'Pricing.PriceCard.UserTier.Details',
		defaultMessage: 'Filled seats',
	});
	const availableSeatsMessage = formatMessage({
		id: 'Pricing.PriceCard.UserTier.AvailableSeats',
		defaultMessage: 'Available seats',
	});

	return (
		<div css={userTierContainerStyles}>
			<div css={toolTipContainerStyles}>
				<div css={userTierMessageStyles}>
					<FormattedMessage
						{...messages.cardUnitCountTierRange}
						values={{
							...DEFAULT_VALUES,
							lowerLimit: formattedUnitLimitLower,
							upperLimit: formattedUnitLimitUpper,
						}}
					/>
				</div>
			</div>
			<Tooltip
				ariaLabel={tooltipAriaLabel}
				buttonSize="small"
				content={`Tier:
                    ${formattedUnitLimitLower} -${' '}${formattedUnitLimitUpper}

                    ${filledSeatsMessage}:
                    ${formattedUnitsInTier}

                    ${availableSeatsMessage}:
                    ${formattedUnitsAvailableInTier}`}
			/>
		</div>
	);
};
